export function capitalize(a) {
  return a.charAt(0).toUpperCase() + a.slice(1);
}
export function isDefined(a) {
  return null !== a && a !== void 0;
}
export function isFunction(a) {
  return !!a && "[object Function]" === {}.toString.call(a);
}